import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { GoalMultiplierValueModal } from "./GoalMultiplierValueModal";
import cls from "./styles.module.scss";

interface GoalMultiplierValueMarkerProps {
  value: number;
}

export const GoalMultiplierValueMarker = ({
  value,
}: GoalMultiplierValueMarkerProps) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const goalMultiplierValues = useGoalsStore((state) => state.initData?.multiplier?.wheel_values);

  if (!goalMultiplierValues || goalMultiplierValues.length === 0) return null;

  return (
    <>
      <button
        className={cls.valueMarker}
        type="button"
        onClick={() => setIsModalOpen(true)}
        aria-label={`x${value}`}
      >
        <span className={cls.valueMarkerCircle}>x{value}</span>
        <span className={cls.valueMarkerLabel}>
          {t("goals.multiplier.lockedLabel")}
        </span>
      </button>

      <GoalMultiplierValueModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        value={value}
        goalMultiplierValues={goalMultiplierValues}
      />
    </>
  );
};
